import { versionEffectsActions } from '@mkp/core/state/actions';
import { debugActions } from '@mkp/debug/actions';
import { FeatureFlag } from '@mkp/debug/models';
import { createFeature, createReducer, on } from '@ngrx/store';

export interface VersionState {
  isNewVersionAvailable: boolean;
}

const initialState: VersionState = {
  isNewVersionAvailable: false,
};

const reducer = createReducer(
  initialState,
  on(versionEffectsActions.newVersionIsAvailable, (state) => ({
    ...state,
    isNewVersionAvailable: true,
  })),
  on(debugActions.toggleFeatureFlag, (state, { featureFlag, value }) => ({
    ...state,
    ...getNewVersionAvailableFromFeatureFlag(featureFlag, value),
  }))
);

export const versionFeature = createFeature({ name: 'versionState', reducer });

const getNewVersionAvailableFromFeatureFlag = (
  featureFlag: FeatureFlag,
  value: boolean
): { isNewVersionAvailable: boolean } | Record<string, never> =>
  featureFlag === 'shouldTriggerSilentUpdate' ? { isNewVersionAvailable: value } : {};
